import { createQueryKey } from '../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../query/types';
import { consumerKeys } from './consumer/keys';

const messagesKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'messages'] as const,
    id: <U extends QueryKeyParam>(messageId: U) =>
      createQueryKey({
        all: [...keys, 'messages', messageId] as const,
        sentBackers: [...keys, 'messages', messageId, 'sentBackers'] as const,
      }),
  });

const communicationIdKey = <T extends QueryKey, U extends QueryKeyParam>(keys: T, scopeId: U) =>
  createQueryKey({
    all: [...keys, scopeId] as const,
    messages: messagesKeys([...keys, scopeId] as const),
  });

const communicationKeys = createQueryKey({
  all: ['communication'] as const,
  id: <T extends QueryKeyParam>(id: T) => communicationIdKey(['communication'] as const, id),
  consumer: consumerKeys(['communication', 'consumer'] as const),
});
export { communicationKeys };
